














import { Component, Vue } from 'vue-property-decorator';
import dxSearchStore from '@/stores/dx/dxSearchStore';

import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxItem,
  DxLabel,
} from 'devextreme-vue/form';

@Component({
  components: {
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxItem,
    DxLabel,
  },
})
export default class SearchBox extends Vue {
  private async searchChanged(e: any) {
    if (!e || !e.value || !e.value.type || !e.value.objectId) {
      return;
    }

    switch (e.value.type) {
      case 'Project':
        this.$router.push({ path: `/projects/${e.value.objectId}` });
        break;
      case 'Contact':
        this.$router.push({ path: `/contacts/${e.value.objectId}` });
        break;
      case 'Company':
        this.$router.push({ path: `/companies/${e.value.objectId}` });
        break;
      case 'Subcontractor':
        this.$router.push({ path: `/subcontractors/${e.value.objectId}` });
        break;
    }
  }

  get searchOptions() {
    const self = this;
    return {
      dataSource: dxSearchStore,
      displayExpr: 'name',
      searchEnabled: true,
      showClearButton: true,
      showCancelButton: true,
      onValueChanged: this.searchChanged,
      itemTemplate: this.getTemplate,
    };
  }

  private getTemplate(e: any) {
    let customHtml = e.name;

    switch (e.type) {
      case 'Project':
        customHtml = '<i class="fas fa-briefcase"></i>&nbsp;' + customHtml;
        break;
    case 'Subcontractor':
        customHtml = '<i class="fas fa-hard-hat"></i>&nbsp;' + customHtml;
        break;
    case 'Contact':
        customHtml = '<i class="fas fa-user"></i>&nbsp;' + customHtml;
        break;
    case 'Company':
        customHtml = '<i class="fas fa-building"></i>&nbsp;' + customHtml;
        break;
    }

    return customHtml;
  }
}
